module.exports = __webpack_public_path__ + "img/osmosis.7565fac0.png";